import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import {
    Divider,
    Button,
    Card,
    CardHeader,
    CardContent,
    IconButton,
    Tooltip,
    Box,
    Stack,
    Typography
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Drawer from '@mui/material/Drawer';
import Paper from '@mui/material/Paper';
import EditIcon from '@mui/icons-material/Edit';
import LoadingButton from '@mui/lab/LoadingButton';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
    DataGrid, gridColumnsTotalWidthSelector,
} from '@mui/x-data-grid';
import SendIcon from '@mui/icons-material/Send';
import LinearProgress from '@mui/material/LinearProgress';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import NorowsData from '../General/NorowsData'
import AddPickup from '../General/AddPickup'
import Printer from '../General/Printer'

import { fetchSenderAddress } from '../../pages/Settings/AddressSender/addressSenderSlice';
import { fetchBoxData } from '../../pages/Settings/Box/boxSlice';
import { fetchPickupDetails, dopostDataCreatePickup } from '../../pages/Reports/Pickup/pickupSlice';
import WidthMaximize from './WidthMaximize'

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    boxShadow: 'unset',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    color: theme.palette.text.secondary,
}));
const getUniqueId = () => {
    return "SCIT" + Date.now().toString(36) + Math.random().toString(36).substr(2)
}
const PickupDrawer = ({ visible, pickupOnClose, pickupItems = {} }) => {
    const dispatch = useDispatch();
    const pickup = useSelector(state => state.pickup && state.pickup.pickupData);
    const pickupCreate = useSelector(state => state.pickup && state.pickup.createPickup);
    const [meta, setMeta] = useState(pickup && pickup.meta);
    const addresssender = useSelector(state => state.addresssender);
    const profile = useSelector(state => state.auth);
    const box = useSelector(state => state.box);
    const [senderAddressObjectId, setSenderAddressObjectId] = useState('');
    const [choosenMeasurementId, setChoosenMeasurementId] = useState(0);
    const [drawer, setDrawer] = useState(true);
    const [printUrl, setPrintUrl] = useState("")
    const [isPrinted, setIsPrinted] = useState(true)
    const [drawerWidth, setDrawerWidth] = useState("80%");
    const [addPickupItemVisible, setAddPickupItemVisible] = useState(false)
    const [removePickupItemId, setRemovePickupItemId] = useState("")
    const [editPickupItemId, setEditPickupItemId] = useState("")
    const [customPickupItems, setCustomPickupItems] = useState([])
    const [addPickupItemData, setAddPickupItemData] = useState({
        "pickup_item_id": getUniqueId(),
        "length": "",
        "width": "",
        "height": "",
        "weight": "",
        "dimension_unit": "in",
        "weight_unit": "lb",
        "choosemeasurement": "",
        "edit_pickup_item_id": "",
        "quantity": "",
        "package_dimension": "",
        "preferred_sender_id": ''
    })
    const [pickupItemErrors, setPickupItemsErrors] = useState({
        "pickup_item_id": "",
        "length": "",
        "width": "",
        "height": "",
        "weight": "",
        "dimension_unit": "",
        "weight_unit": "",
        "choosemeasurement": "",
        "quantity": "",
        "package_dimension": "",
        "preferred_sender_id": ''
    });

    const isIntegerValue = (value) => {
        value = Number(value);
        if (Number.isInteger(value)) {
            return true;
        }
        return false;
    }

    const validatePickupItemData = (data) => {
        let isValid = true
        let pickupItemErrorsTemp = {
            "pickup_item_id": "",
            "length": "",
            "width": "",
            "height": "",
            "dimension_unit": "",
            "weight": "",
            "weight_unit": "",
            "choosemeasurement": "",
            "quantity": "",
            "package_dimension": "",
            "preferred_sender_id": ''
        };

        if (data.length == "" || Number(data.length) <= 0) {
            isValid = false
            pickupItemErrorsTemp.length = "Length is required and should be valid";
        }
        if (data.width == "" || Number(data.width) <= 0) {
            isValid = false
            pickupItemErrorsTemp.width = "Width is required and should be valid";
        }

        if (data.height == "" || Number(data.height) <= 0) {
            isValid = false
            pickupItemErrorsTemp.height = "Height is required and should be valid";
        }

        if (data.weight == "" || Number(data.weight) <= 0) {
            isValid = false
            pickupItemErrorsTemp.weight = "Weight is required and should be valid";
        }

        if (data.quantity == "" || Number(data.quantity) <= 0 || !Number.isInteger(Number(data.quantity))) {
            isValid = false
            pickupItemErrorsTemp.quantity = "Quantity is required and should be valid";
        }

        setPickupItemsErrors(pickupItemErrorsTemp)
        return isValid
    }



    const initialColumns = [
        {
            field: 'package_dimension',
            headerName: 'Package Dimension',
            headerClassName: 'super-app-theme--header',
            sortable: false,
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                if (params.row.package_dimension) {
                    return params.row.package_dimension
                } else {
                    return "-"
                }
            }
        },
        {
            field: 'dimension_unit',
            headerName: 'Dimension Unit',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                if (params.row.dimension_unit) {
                    return params.row.dimension_unit
                } else {
                    return "-"
                }
            }
        },
        {
            field: 'weight',
            headerName: 'Weight',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                if (params.row.weight) {
                    return params.row.weight
                } else {
                    return "-"
                }
            }
        },
        {
            field: 'weight_unit',
            headerName: 'Weight Unit',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                if (params.row.weight_unit) {
                    return params.row.weight_unit
                } else {
                    return "-"
                }
            }
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                if (params.row.quantity) {
                    return params.row.quantity
                } else {
                    return "-"
                }
            }
        },
        {
            field: 'action',
            headerName: 'Action',
            headerClassName: 'super-app-theme--header',
            width: 100,
            resizable: false,
            hide: (customPickupItems.length == 0),
            renderCell: (params) => {
                if (params.row && params.row.pickup_item_id && params.row.pickup_item_id != "") {
                    return <>
                        <span>
                            <Tooltip title="Edit" placement="left-start" disableFocusListener={false}>
                                <IconButton>
                                    <EditIcon style={{ color: 'rgba(0,0,0,.54)', cursor: 'pointer' }} onClick={() => setEditPickupItemId(params.row.pickup_item_id)} />
                                </IconButton>
                            </Tooltip>
                        </span>
                        <span>
                            <Tooltip title="Delete" placement="left-start" disableFocusListener={false}>
                                <IconButton>
                                    <DeleteOutlineOutlinedIcon style={{ color: 'rgba(0,0,0,.54)', cursor: 'pointer' }}
                                        onClick={() => setRemovePickupItemId(params.row.pickup_item_id)}
                                    />
                                </IconButton>
                            </Tooltip>
                        </span>
                    </>;
                } else {
                    return <>-</>;
                }
            }

        }
    ];

    const [columns, setColumns] = useState(initialColumns)

    const handlePackageDimensionInputChange = (event) => {
        if (event.target.name == "choosenmeasurement") {
            let pickupItemErrorsInitial = {
                "pickup_item_id": "",
                "length": "",
                "width": "",
                "height": "",
                "dimension_unit": "",
                "weight": "",
                "weight_unit": "",
                "choosemeasurement": "",
                "quantity": "",
                "package_dimension": "",
                "preferred_sender_id": ''
            };
            if (event.target.value != 0) {
                box && box.data && box.data.map((boxData) => {
                    if (boxData._id === event.target.value) {
                        setAddPickupItemData({
                            ...addPickupItemData,
                            ["pickup_item_id"]: getUniqueId(),
                            ['length']: parseFloat(boxData.box_length).toFixed(2),
                            ['width']: parseFloat(boxData.box_width).toFixed(2),
                            ['height']: parseFloat(boxData.box_height).toFixed(2),
                            ['weight']: parseFloat(boxData.box_weight).toFixed(2),
                            ['weight_unit']: boxData.box_weight_unit,
                            ['dimension_unit']:boxData.box_length_unit,
                            ["choosemeasurement"]: event.target.value
                        })
                        setPickupItemsErrors(pickupItemErrorsInitial)
                    }
                })
            } else {
                setAddPickupItemData({
                    "pickup_item_id": getUniqueId(),
                    "length": "",
                    "width": "",
                    "height": "",
                    "dimension_unit": "in",
                    "edit_pickup_item_id": "",
                    "weight": "",
                    "weight_unit": "lb",
                    "choosemeasurement": "0",
                    "quantity": "",
                    "package_dimension": "",
                })
                setPickupItemsErrors(pickupItemErrorsInitial)
            }
        }
    }
    const dispatchSenderAddressCallback = (id) => {
        setSenderAddressObjectId(id)
        setAddPickupItemData({
            ...addPickupItemData,
            ['preferred_sender_id']: id,
        })

        setPickupItemsErrors({ "preferred_sender_id": "" })
    }
    const formDataHandler = e => {
        const { name, value } = e.target
        setAddPickupItemData({
            ...addPickupItemData,
            [name]: value
        })
        validatePickupItemData({
            ...addPickupItemData,
            [name]: value
        });
    }

    const onAddPickupModalClose = () => {
        setRemovePickupItemId("")
        setEditPickupItemId("")
        setAddPickupItemData({
            "pickup_item_id": getUniqueId(),
            "length": "",
            "width": "",
            "height": "",
            "dimension_unit": "in",
            "weight": "",
            "weight_unit": "lb",
            "choosemeasurement": "",
            "edit_pickup_item_id": "",
            "quantity": "",
            "package_dimension": "",
        })
        setPickupItemsErrors({
            "pickup_item_id": "",
            "length": "",
            "width": "",
            "height": "",
            "weight": "",
            "dimension_unit": "",
            "weight_unit": "",
            "choosemeasurement": "",
            "quantity": "",
            "package_dimension": ""
        })
        setAddPickupItemVisible(false)
    }
    const onAddPickupItemClick = () => {
       
        if (validatePickupItemData(addPickupItemData)) {
           
            let customPickupItemData = [...customPickupItems];
            if (addPickupItemData.edit_pickup_item_id == "") {
                setAddPickupItemData({
                    ...addPickupItemData,
                    ['package_dimension']: parseFloat(addPickupItemData.length).toFixed(2) + "x" + parseFloat(addPickupItemData.width).toFixed(2) + "x" + parseFloat(addPickupItemData.height).toFixed(2)
                })
                customPickupItemData.push(addPickupItemData)
                setCustomPickupItems(customPickupItemData)
                setAddPickupItemData({
                    "pickup_item_id": getUniqueId(),
                    "length": "",
                    "width": "",
                    "height": "",
                    "weight": "",
                    "dimension_unit": "",
                    "weight_unit": "",
                    "choosemeasurement": "",
                    "quantity": "",
                    "package_dimension": ""
                })
            } else if (addPickupItemData.edit_pickup_item_id != "") {
                setAddPickupItemData({
                    ...addPickupItemData,
                    ['package_dimension']: addPickupItemData.length + "x" + addPickupItemData.width + "x" + addPickupItemData.height
                })
                let customPickupItemData = [...customPickupItems];
                let newPickupItemData = [];
                customPickupItemData.map((item) => {
                    if (item && item.pickup_item_id && item.pickup_item_id == addPickupItemData.edit_pickup_item_id) {
                        newPickupItemData.push(addPickupItemData)
                    } else {
                        newPickupItemData.push(item)
                    }
                })
                setCustomPickupItems(newPickupItemData)
            }
            onAddPickupModalClose()

        } else {
            console.log("Errors in line items")
        }
    }
    const handleSubmit = (e) => {
        let apikey = (profile.profile.api_token) ? profile.profile.api_token : "";
        let finalData = {}
        finalData = {
            "sender_id": senderAddressObjectId,
            "items": customPickupItems
        }
        dispatch(dopostDataCreatePickup(profile.profile.id,finalData, apikey,meta))
    }

    const ondrawerclose = () => {
        setCustomPickupItems([])
        setDrawer(false)
        pickupOnClose(false)
    }

    useEffect(() => {
       
        customPickupItems.forEach(object => {
            object.package_dimension =parseFloat(object.length).toFixed(2) + "x" + parseFloat(object.width).toFixed(2) + "x" + parseFloat(object.height).toFixed(2);
          });
        setColumns(initialColumns)
    }, [customPickupItems])

    useEffect(() => {
        if (removePickupItemId != "" && removePickupItemId != "undefined") {
            let customPickupItemData = [...customPickupItems];
            let newPickupItemData = [];
            customPickupItemData.map((item) => {
                if (item && item.pickup_item_id && item.pickup_item_id != removePickupItemId) {
                    newPickupItemData.push(item)
                }
            })
            setCustomPickupItems(newPickupItemData)
        }
    }, [removePickupItemId])

    useEffect(() => {
        if (editPickupItemId != "" && editPickupItemId != "undefined" && !_.isUndefined(_.find(customPickupItems, ['pickup_item_id', editPickupItemId]))) {
            console.log("Found edit")
            let editData = _.find(customPickupItems, ['pickup_item_id', editPickupItemId])
            editData[`edit_pickup_item_id`] = editPickupItemId
            setAddPickupItemData(editData)
            setAddPickupItemVisible(true)
        }
    }, [editPickupItemId])

    useEffect(() => {
        if (addresssender && addresssender.data) {
            addresssender.data.map((item) => {
                if (item && item.default) {
                    setSenderAddressObjectId(item._id)
                    setAddPickupItemData({
                        ...addPickupItemData,
                        ['preferred_sender_id']: item._id,
                    })
                }
            })
        }
    }, [addresssender]);

    useEffect(() => {
        dispatch(fetchSenderAddress());
        dispatch(fetchBoxData(false));
    }, [dispatch]);

    useEffect(() => {
        if (pickupCreate && pickupCreate.notification && pickupCreate.notification.messageContent
            && pickupCreate.notification.messageContent[0] === 'Pickup Created Successfully') {
                if(pickupCreate && pickupCreate.message && pickupCreate.message.label_url_direct){
                    setPrintUrl(pickupCreate.message.label_url_direct)
                    setIsPrinted(false)
                    ondrawerclose()
                }
        }
    }, [pickupCreate]);
    return (
        <>
            <Printer isPrinted={isPrinted} setIsPrinted={setIsPrinted} print_url={printUrl} />

            <Drawer
                anchor="right"
                open={visible}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        ondrawerclose();
                    }
                }}
                PaperProps={{
                    sx: { width: drawerWidth, bgcolor: '#F8FAFC' },
                }}
            >
                {/* Layout Wrapper Container Layer */}
                <Box sx={{ p: 4, height: '100%', boxSizing: 'border-box', overflowY: 'auto' }}>
                    <Stack spacing={3}>
                        
                        {/* ==================== CORE CONTROL & BRAND PANEL HEADER ==================== */}
                        <Card 
                            sx={{ 
                                backgroundColor: '#FFFFFF',
                                border: '1px solid #E2E8F0',
                                borderRadius: '16px',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.03)',
                                overflow: 'hidden'
                            }} 
                            className="sc--cardhead--details"
                        >
                            <CardHeader 
                                title={
                                    <Typography variant="h6" component="h1" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px', m: 0 }}>
                                        Pickup Drawer
                                    </Typography>
                                } 
                                action={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <WidthMaximize
                                            defaultWidth="80%"
                                            onToggle={(newWidth) => setDrawerWidth(newWidth)}
                                        />
                                        <Tooltip title="Close Panel" placement="top">
                                            <IconButton 
                                                aria-label="close" 
                                                onClick={ondrawerclose}
                                                sx={{ 
                                                    color: '#64748B', 
                                                    borderRadius: '8px', 
                                                    border: '1px solid #E2E8F0',
                                                    p: 0.75,
                                                    transition: 'all 0.15s ease-in-out',
                                                    '&:hover': { backgroundColor: '#F1F5F9', color: '#1E293B', borderColor: '#CBD5E1' }
                                                }}
                                            >
                                                <CloseIcon sx={{ fontSize: '18px' }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                }
                                sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                            />
                            {(pickupCreate && pickupCreate.loading === true) && (
                                <LinearProgress sx={{ height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }} />
                            )}
                            <Divider sx={{ borderColor: '#E2E8F0' }} />
                        </Card>

                        <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                            <Stack spacing={3}>
                                
                                {/* ==================== CONFIGURATION VIEW A: ORIGIN ROUTING PROPERTIES ==================== */}
                                <Card 
                                    sx={{ 
                                        width: '100%',
                                        backgroundColor: '#FFFFFF',
                                        border: '1px solid #E2E8F0',
                                        borderRadius: '16px',
                                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.01)',
                                        overflow: 'hidden'
                                    }}
                                    className="sc--cardhead--details"
                                >
                                    <CardHeader 
                                        title={
                                            <Typography variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '15px' }}>
                                                Pickup Address Details
                                            </Typography>
                                        } 
                                        sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                                    />
                                    <Divider sx={{ borderColor: '#E2E8F0' }} />
                                    <CardContent sx={{ p: 3 }}>
                                        <Box sx={{ width: '100%', maxWidth: '70ch', mx: 'auto', py: 1 }}>
                                            <FormControl fullWidth variant="outlined" size="small" error={!!pickupItemErrors.preferred_sender_id}>
                                                <InputLabel id="pickup-address-select-label">Pickup Address</InputLabel>
                                                <Select
                                                    labelId="pickup-address-select-label"
                                                    id="demo-simple-select-standard"
                                                    name="preferred_sender_id"
                                                    value={senderAddressObjectId}
                                                    onChange={e => {
                                                        dispatchSenderAddressCallback(e.target.value)
                                                        setPickupItemsErrors({ "preferred_sender_id": "" })
                                                    }}
                                                    label="Pickup Address"
                                                    sx={{ borderRadius: '10px' }}
                                                >
                                                    {addresssender && addresssender.data && addresssender.data.map((item) => {
                                                        return (
                                                            <MenuItem value={item._id} key={item._id} sx={{ py: 1, borderBottom: '1px solid #F1F5F9' }}>
                                                                <Typography variant="body2" sx={{ color: '#1E293B', fontWeight: 500 }}>
                                                                    <strong>{item.sender_name}</strong> ({item.sender_company})<br />
                                                                    <small style={{ color: '#64748B' }}>{item.sender_address}, {item.sender_city}, {item.sender_state_code}, {item.sender_country_code} - {item.sender_postal_code}</small>
                                                                </Typography>
                                                            </MenuItem>
                                                        )
                                                    })}
                                                </Select>

                                                <FormHelperText sx={{ mx: 0.5, mt: 0.75, fontWeight: 500 }}>
                                                    {(addresssender && addresssender.loading === false)
                                                        && addresssender && addresssender.data && addresssender.data.length == 0 &&
                                                        <Typography component="span" variant="caption" sx={{ color: "#EF4444", fontWeight: 600 }}>
                                                            Please add pickup address
                                                            <Link to="/settings/address-sender" style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 700 }}> here </Link>
                                                        </Typography>
                                                    }
                                                    {/* {errors.preferred_sender_id && addresssender && addresssender.data && addresssender.data.length !== 0 &&
                                                        <span style={{ color: "red" }}>
                                                            This field is required.
                                                        </span>
                                                    } */}
                                                </FormHelperText>
                                            </FormControl>
                                        </Box>
                                    </CardContent>
                                </Card>

                                {/* ==================== CONFIGURATION VIEW B: PACKAGING MATRIX SPECIFICATIONS ==================== */}
                                <Card
                                    sx={{ 
                                        width: '100%',
                                        backgroundColor: '#FFFFFF',
                                        border: '1px solid #E2E8F0',
                                        borderRadius: '16px',
                                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.01)',
                                        overflow: 'hidden'
                                    }}
                                    className="sc--cardhead--details"
                                >
                                    <CardHeader
                                        title={
                                            <Typography variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '15px' }}>
                                                Package Details
                                            </Typography>
                                        }
                                        action={
                                            <Button 
                                                variant="outlined" 
                                                size="small"
                                                aria-label="settings" 
                                                onClick={() => setAddPickupItemVisible(true)}
                                                sx={{
                                                    textTransform: 'none',
                                                    borderRadius: '8px',
                                                    fontWeight: 700,
                                                    fontSize: '12.5px',
                                                    height: '32px',
                                                    borderColor: '#1976d2',
                                                    color: '#1976d2',
                                                    '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.04)', borderColor: '#115293' }
                                                }}
                                            >
                                                Add Package
                                            </Button>
                                        }
                                        sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                                    />
                                    <Divider sx={{ borderColor: '#E2E8F0' }} />
                                    <CardContent sx={{ p: 3 }}>
                                        {addPickupItemVisible && (
                                            <AddPickup
                                                addPickupItemVisible={addPickupItemVisible}
                                                onAddPickupModalClose={onAddPickupModalClose}
                                                formDataHandler={formDataHandler}
                                                onAddPickupItemClick={onAddPickupItemClick}
                                                addPickupItemData={addPickupItemData}
                                                editPickupItemId={editPickupItemId}
                                                handlePackageDimensionInputChange={handlePackageDimensionInputChange}
                                                errors={pickupItemErrors}
                                            />
                                        )}
                                        
                                        <Box sx={{ width: '100%', mt: 1, border: '1px solid #E2E8F0', borderRadius: '12px', overflow: 'hidden' }}>
                                            <DataGrid
                                                getRowId={(row) => Math.random() + Math.random()}
                                                rows={customPickupItems || []}
                                                columns={columns}
                                                autoHeight={true}
                                                disableColumnFilter={true}
                                                disableColumnMenu={true}
                                                sortingMode="server"
                                                pageSize={5}
                                                disableRowSelectionOnClick
                                                loading={!!(pickup && pickup.loading)}
                                                sx={{
                                                    border: 'none',
                                                    backgroundColor: '#FFFFFF',
                                                    '& .MuiDataGrid-topContainer': { backgroundColor: '#F8FAFC' },
                                                    '& .MuiDataGrid-columnHeader': { color: '#475569', fontWeight: 700, fontSize: '13px', '&:focus, &:focus-within': { outline: 'none' } },
                                                    '& .MuiDataGrid-row': { transition: 'background-color 0.15s ease-in-out', borderBottom: '1px solid #F1F5F9', alignItems: 'center', '&:hover': { backgroundColor: '#F8FAFC' } },
                                                    '& .MuiDataGrid-cell': { borderBottom: 'none', display: 'flex', alignItems: 'center', py: '12px', '&:focus, &:focus-within': { outline: 'none' } },
                                                    '& .MuiLinearProgress-root': { height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }
                                                }}
                                                slots={{
                                                    noRowsOverlay: NorowsData,
                                                    loadingOverlay: LinearProgress
                                                }}
                                            />
                                        </Box>
                                    </CardContent>
                                </Card>

                                {/* Operational Footer Bar Actions Panel Section */}
                                <Box 
                                    className="sc--form--center" 
                                    sx={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        justifyContent: 'center', 
                                        gap: 2, 
                                        mt: 2,
                                        pt: 1
                                    }}
                                >
                                    <LoadingButton
                                        variant="contained"
                                        onClick={e => handleSubmit(e)}
                                        disabled={!!(customPickupItems && customPickupItems.length == 0)}
                                        loading={!!(pickupCreate && pickupCreate.loading)}
                                        startIcon={<SendIcon sx={{ fontSize: '16px !important' }} />}
                                        sx={{
                                            textTransform: 'none', 
                                            borderRadius: '10px', 
                                            fontWeight: 700, 
                                            fontSize: '13.5px', 
                                            height: '38px', 
                                            px: 4, 
                                            boxShadow: 'none',
                                            backgroundColor: '#1976d2', 
                                            color: '#FFFFFF', 
                                            '&:hover': { backgroundColor: '#115293', boxShadow: 'none' },
                                            '&.Mui-disabled': { backgroundColor: '#E2E8F0', color: '#94A3B8' }
                                        }}
                                    >
                                        Create Pickup
                                    </LoadingButton>
                                </Box>
                            </Stack>
                        </CardContent>
                    </Stack>
                </Box>
            </Drawer>
        </>
    )
}


export default PickupDrawer;